export const TOGGLE_SMS_ALERTS_SUCCESS = 'TOGGLE_SMS_ALERTS_SUCCESS';

export const LOAD_SMS_ALERTS_FAIL = 'LOAD_SMS_ALERTS_FAIL';
export const LOAD_SMS_ALERTS_REQUEST = 'LOAD_SMS_ALERTS_REQUEST';
export const LOAD_SMS_ALERTS_SUCCESS = 'LOAD_SMS_ALERTS_SUCCESS';
